export const giftMessages: { [key: number]: string } = {
  1: "Mini photo album",
  2: "AirPods and Case",
  3: "Body Shop Kit",
  4: "Bath & Body Works Assortment",
  5: "Tongue Scraper",
  6: "DIFAN Head Spa",
  7: "Escape Simulator",
  8: "Crochet Dinosaur",
  9: "Cat Lamp",
  10: "Stitch Slot Machine",
  11: "Wooden Camellia",
  12: "Sukoshi Earrings (2)",
  13: "Squishmallow",
  14: "Stitch Blindbox",
  15: "Golf with your friends",
  16: "Capybara Plush",
  17: "One Piece Funko Pop",
  18: "Essentials Hoodie",
  19: "CarbonCopy Jacket",
  20: "Tennis Racket",
  21: "Terraria",
  22: "LABUBU",
  23: "Custom Shirts",
  24: "Sakura Bonsai 3D Puzzle",
  25: "GOLF",
  26: "Human Fall Flat",
  27: "Star Map Print",
  28: "Origami Roses",
  29: "DELAYED",
  30: "Saree",
};